// Routes de tc_learn (par le broker, préfixe `/tc_learn`) : la file de
// correction humaine des quêtes partagées (lot L6). Réservées aux rôles ADMIN
// et REVIEWER — tc_learn refuse le reste en 401/403, quel que soit son mode.
export const QUEST_REVIEW_ENDPOINTS = {
  QUEUE: "/admin/body-queue",
  VALIDATE: (bodyId: string) => `/admin/bodies/${bodyId}/validate`,
  REJECT: (bodyId: string) => `/admin/bodies/${bodyId}/reject`,
  CORRECT: (bodyId: string) => `/admin/bodies/${bodyId}/correct`,
  CLOSE_QUEST: (questId: string) => `/admin/quests/${questId}/close`,
  BY_DOCUMENT: "/admin/quality/by-document",
} as const;
